import React from 'react';

export default function FloatingCTA() {
  const contactActions = [
    {
      id: 'phone',
      label: 'Ring (+45) 5162 7235',
      href: 'tel:+4551627235',
      icon: 'fa-solid fa-phone',
      bgClass: 'bg-[#34657f] hover:bg-[#244c60] text-white',
      external: false,
    },
    {
      id: 'email',
      label: 'Send e-mail',
      href: 'mailto:tk@kopplaw.dk',
      icon: 'fa-solid fa-envelope',
      bgClass: 'bg-[#1A5B69] hover:bg-[#134651] text-white',
      external: false,
    },
    {
      id: 'linkedin',
      label: 'LinkedIn profil',
      href: 'https://www.linkedin.com/in/titti-kopp-31611517/',
      icon: 'fa-brands fa-linkedin-in',
      bgClass: 'bg-[#0077b5] hover:bg-[#005f93] text-white',
      external: true,
    },
  ];

  return (
    <aside
      aria-label="Hurtig kontakt genveje"
      className="fixed bottom-5 right-4 sm:bottom-7 sm:right-6 z-40 flex flex-col gap-2.5 sm:gap-3 items-end pointer-events-auto"
    >
      {contactActions.map((action) => (
        <div key={action.id} className="relative group flex items-center">
          {/* Desktop Hover Tooltip */}
          <span
            className="hidden sm:inline-block pointer-events-none absolute right-full mr-3 px-3 py-1.5 bg-[#1c3848] text-white text-xs font-medium rounded-sm shadow-md whitespace-nowrap opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200"
            role="tooltip"
          >
            {action.label}
          </span>

          {/* Action Button */}
          <a
            href={action.href}
            target={action.external ? '_blank' : undefined}
            rel={action.external ? 'noopener noreferrer' : undefined}
            aria-label={action.label}
            className={`w-11 h-11 sm:w-12 sm:h-12 rounded-full flex items-center justify-center shadow-lg transition-all duration-200 hover:scale-108 active:scale-95 focus:outline-none focus:ring-2 focus:ring-white/60 ${action.bgClass}`}
          >
            <i className={`${action.icon} text-sm sm:text-base`} aria-hidden="true" />
          </a>
        </div>
      ))}
    </aside>
  );
}
